import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public isValid$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private updatePhoto = new Subject();

  public updateOpenDialog(value: boolean): void {
    this.isValid$.next(value);
  }

  someActionEmitted$(): Observable<unknown> {
    return this.updatePhoto.asObservable();
  }

  emitSomeAction(check: string): void {
    this.updatePhoto.next(check);
  }
}
